import { library } from '@fortawesome/fontawesome-svg-core'

/*
 * Import as per recommended in Font Awesome docs
 * Order: 'far', 'fal', 'fas'
 * https://fontawesome.com/how-to-use/javascript-api/setup/importing-icons
 */

import {
  faAngleLeft as farAngleLeft,
  faArrowLeft as farArrowLeft,
  faBars as farBars,
  faBell as farBell,
  faCheck as farCheck,
  faChevronDown as farChevronDown,
  faChevronUp as farChevronUp,
  faClock as farClock,
  faExclamationCircle as farExclamationCircle,
  faExclamationTriangle as farExclamationTriangle,
  faLockAlt as farLockAlt,
  faQuestionCircle as farQuestionCircle,
  faSpinner as farSpinner,
  faTimes as farTimes,
  faUndo as farUndo
} from '@fortawesome/pro-regular-svg-icons'

import {
  faCalendarAlt as falCalendarAlt,
  faCalendarExclamation as falCalendarExclamation,
  faCheck as falCheck,
  faCheckCircle as falCheckCircle,
  faCircle as falCircle,
  faCreditCard as falCreditCard,
  faEnvelopeOpenText as falEnvelopeOpenText,
  faExclamationCircle as falExclamationCircle,
  faMinus as falMinus,
  faTimes as falTimes,
  faTools as falTools,
  faUserCheck as falUserCheck
} from '@fortawesome/pro-light-svg-icons'

import {
  faArrowAltToBottom as fasArrowAltToBottom,
  faArrowUp as fasArrowUp,
  faCaretDown as fasCaretDown,
  faCheck as fasCheck,
  faCircle as fasCircle,
  faDownload as fasDownload,
  faExclamationCircle as fasExclamationCircle,
  faExclamationTriangle as fasExclamationTriangle,
  faFax as fasFax,
  faPhone as fasPhone,
  faPlusCircle as fasPlusCircle,
  faQuestionCircle as fasQuestionCircle,
  faReply as fasReply,
  faSearch as fasSearch,
  faUserPlus as fasUserPlus
} from '@fortawesome/pro-solid-svg-icons'

const Icons = {
  falCalendarAlt,
  falCalendarExclamation,
  falCheck,
  falCheckCircle,
  falCircle,
  falCreditCard,
  falEnvelopeOpenText,
  falExclamationCircle,
  falMinus,
  falTimes,
  falTools,
  falUserCheck,
  farAngleLeft,
  farArrowLeft,
  farBars,
  farBell,
  farCheck,
  farChevronDown,
  farChevronUp,
  farClock,
  farExclamationCircle,
  farExclamationTriangle,
  farLockAlt,
  farQuestionCircle,
  farSpinner,
  farTimes,
  farUndo,
  fasArrowAltToBottom,
  fasArrowUp,
  fasCaretDown,
  fasCheck,
  fasCircle,
  fasDownload,
  fasExclamationCircle,
  fasExclamationTriangle,
  fasFax,
  fasPhone,
  fasPlusCircle,
  fasQuestion: fasQuestionCircle,
  fasReply,
  fasSearch,
  fasUserPlus
}

library.add(...Object.values(Icons))

export type IconNames = keyof typeof Icons
